<template>
<div>
    <v-card>
        <v-card-title>
            <span class="headline">Edit Student</span>
        </v-card-title>
        <v-card-text>
            <div v-if="laravelErrors.active" class="text-xs-center">
                <v-chip v-for="(msg,key) in laravelErrors.messages" :key="key" label color="red" text-color="white">{{ msg[0] }}
                </v-chip>
            </div>
            <v-form @submit.prevent="addStudent">
                <v-text-field name="first_name" v-model="student.first_name" label="Legal First Name" v-validate="'required'">
                </v-text-field>
                <span class="error--text">{{ errors.first('first_name') }}</span>
                <v-text-field name="last_name" v-model="student.last_name" label="Legal Last Name" v-validate="'required'">
                </v-text-field>
                <span class="error--text">{{ errors.first('last_name') }}</span>
                <v-select name="grade" :items="grades" label="Grade Level" v-model="student.grade" item-value="value" v-validate="'required'">
                </v-select>
                <span class="error--text">{{ errors.first('grade') }}</span>
                <v-card-actions mt-3>
                    <v-btn class="white--text blue darken-1" :loading="loading" @click="update()">Update</v-btn>
                    <v-btn class="white--text blue darken-1" @click="$emit('close')">Cancel</v-btn>
                </v-card-actions>
            </v-form>
        </v-card-text>
    </v-card>

</div>
</template>

<script>
import axios from 'axios'
import throttle from 'lodash.throttle'

export default {
    props: ['active', 'studentData'],
    data() {
        return {
            loading: false,
            grades: [{
                    text: 'Kindergarten',
                    value: 'K'
                },
                {
                    text: '1st',
                    value: '1'
                },
                {
                    text: '2nd',
                    value: '2'
                },
                {
                    text: '3rd',
                    value: '3'
                },
                {
                    text: '4th',
                    value: '4'
                },
                {
                    text: '5th',
                    value: '5'
                },
                {
                    text: '6th',
                    value: '6'
                },
                {
                    text: '7th',
                    value: '7'
                },
                {
                    text: '8th',
                    value: '8'
                },
                {
                    text: '9th',
                    value: '9'
                },
                {
                    text: '10th',
                    value: '10'
                },
                {
                    text: '11th',
                    value: '11'
                },
                {
                    text: '12th',
                    value: '12'
                },
                {
                    text: 'Done',
                    value: 'done'
                }
            ]
        }
    },
    computed: {
        student() {
            return this.studentData
        },
        laravelErrors() {
            return this.$store.state.errorModule.validation
        }
    },
    watch: {
        'active': function (value) {
            if (!value) {
                this.errors.clear()
                this.$store.commit('clearErrors')
            }
        }
    },
    methods: {
        update: throttle(function () {
            this.loading = true
            this.$store.commit('clearErrors')

            this.$validator.validateAll().then((result) => {
                if (result) {
                    setTimeout(() => {
                        axios.put('/api/students/' + this.student.id, this.student).then((response) => {
                                this.loading = false
                                this.$store.commit('updateSession', response.data.students)
                                this.$emit('success')
                                this.$emit('close')
                            })
                            .catch((errors) => {
                                this.loading = false
                                this.$store.commit('setValidationErrors', errors)
                            })
                    }, 500)

                } else {
                    this.loading = false
                }
            })
        }, 1000)
    }
}
</script>
